import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
// import BB from './images/BB.png';
// import { FaArrowLeft } from 'react-icons/fa';
import ArrowLeft from './images/ArrowLeft.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';

const DEFAULT_IMAGE =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAiIGhlaWdodD0iMjUwIiB2aWV3Qm94PSIwIDAgMjUwIDI1MCI+PHJlY3Qgd2lkdGg9IjI1MCIgaGVpZ2h0PSIyNTAiIGZpbGw9IiNGMEYwRjAiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZG9taW5hbnQtYmFzZWxpbmU9ImNlbnRyYWwiIGZvbnQtc2l6ZT0iMjAiIGZpbGw9IiM4ODgiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==';
  
const MyCategories = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);

    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(true);
    const [loadingProgress, setLoadingProgress] = useState(0);

    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;

    // Simulate loading progress
    useEffect(() => {
        if (loader) {
            const progressInterval = setInterval(() => {
                setLoadingProgress(prevProgress => {
                    if (prevProgress >= 90) {
                        clearInterval(progressInterval);
                        return 90;
                    }
                    return prevProgress + 10;
                });
            }, 500);

            return () => clearInterval(progressInterval);
        }
    }, [loader]);

    const fetchVendorCategories = useCallback(async (vendorData) => {
        try {
            const response = await fetch(
                `${fetchUrl}product-category/get-productCategoriesBy-vendor_id?vendor_id=${vendorData.id}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-token': vendorData.token,
                    },
                }
            );
            const result = await response.json();
            console.log('Vendor Categories:', result);
            return result.success ? result.data : [];
        } catch (error) {
            console.error('Error fetching vendor categories:', error);
            return [];
        }
    }, [fetchUrl]);

    const fetchAllCategories = useCallback(async (vendorData) => {
        try {
            const response = await fetch(
                `${fetchUrl}product-category/get-quick-buy-product-categories`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-token': vendorData.token,
                    },
                }
            );
            const result = await response.json();
            return result.success ? result.data : [];
        } catch (error) {
            console.error('Error fetching all categories:', error);
            return [];
        }
    }, [fetchUrl]);

    const fetchSellingItemsCount = useCallback(async (vendorData) => {
        try {
            const response = await fetch(
                `${fetchUrl}product/get-vendor-product-categories-count?vendor_id=${vendorData.id}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-token': vendorData.token,
                    },
                }
            );
            const result = await response.json();
            return result.success ? result.data.productCategorys : [];
        } catch (error) {
            console.error('Error fetching selling counts:', error);
            return [];
        }
    }, [fetchUrl]);

    const fetchAllData = useCallback(async () => {
        try {
            const vendorDataString = localStorage.getItem('vendorData');
            if (!vendorDataString) throw new Error('No vendor data found');
            const vendorData = JSON.parse(vendorDataString);
            if (!vendorData?.id || !vendorData?.token) throw new Error('Invalid vendor data');

            setLoading(true);
            setLoader(true);
            setLoadingProgress(0);

            const [vendorCategories, allCategories, sellingCounts] = await Promise.all([
                fetchVendorCategories(vendorData),
                fetchAllCategories(vendorData),
                fetchSellingItemsCount(vendorData),
            ]);

            const combined = vendorCategories.map((vendorCategory) => {
                const match = allCategories.find(c => c._id === vendorCategory._id);
                const selling = sellingCounts.find(c => c.product_category_id === vendorCategory._id);
                return {
                    id: vendorCategory._id,
                    name: vendorCategory.product_category_name || 'Unknown Category',
                    image: vendorCategory.product_category_image
                        ? imageUrl + vendorCategory.product_category_image
                        : null,
                    description: vendorCategory.product_category_description || '',
                    sellingCount: selling?.items_count || 0,
                    totalCount: match?.total_products_count || 0,
                };
            });

            setCategories(combined);
            setLoadingProgress(100);
            setError('');
        } catch (err) {
            console.error('Fetch error:', err);
            setError(err.message || 'Failed to load categories');
        } finally {
            setLoading(false);
            setTimeout(() => {
                setLoader(false);
            }, 500);
        }
    }, [fetchVendorCategories, fetchAllCategories, fetchSellingItemsCount, imageUrl]);

    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);



   const handleCategoryPress = (category) => {
  // ✅ Get vendor data from localStorage
  const vendorDataString = localStorage.getItem("vendorData");
  const vendorData = vendorDataString ? JSON.parse(vendorDataString) : null;

  if (!vendorData || !vendorData.id || !vendorData.token) {
    console.error("❌ Missing vendor data — redirecting to login");
    navigate("/supplier/login");
    return;
  }

  // ✅ Navigate and send both category + vendor data
  navigate("/supplier/itemlist", {
    state: {
      vendorData, // important
      categoryId: category.id,
      categoryName: category.name,
      categoryData: category,
    },
  });
};


    const handleSaveAndContinue = () => {
        // You can add API call or navigation here
        // navigate('/vendor/home'); // Change route if needed
    };

    const onRefresh = useCallback(async () => {
        setRefreshing(true);
        await fetchAllData();
        setRefreshing(false);
    }, [fetchAllData]);

   const LoadingSpinner = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
    <div className="relative">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="animate-spin w-16 h-16 border-4 border-[#F43042] border-t-transparent rounded-full animate-spin"></div>
      </div>
      <div className="mt-24 text-center">
        <p className="text-[#524D4D] font-medium animate-pulse">
           Loading My Categories...
        </p>
      </div>
    </div>
  </div>
);

// Progress Loader Component
const ProgressLoader = ({ progress }) => (
  <div className="fixed top-0 left-0 right-0 z-[60]">
    <div 
      className="h-1 bg-[#F43042]" 
      style={{ 
        width: `${progress}%`, 
        transition: 'width 0.5s ease-in-out' 
      }}
    ></div>
  </div>
);

    if (error) {
        return (
            <div className="w-full min-h-screen bg-white flex justify-center items-center">
                <div className="text-center px-4">
                    <div className="text-red-500 text-6xl mb-4">⚠️</div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Error Loading Categories</h2>
                    <p className="text-gray-600 mb-4">{error}</p>
                    <button
                        onClick={fetchAllData}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full min-h-screen bg-white">
            {/* Loader Components */}
            {loader && (
                <>
                    <ProgressLoader progress={loadingProgress} />
                    <LoadingSpinner />
                </>
            )}
            {/* Header */}
        <div className="sticky top-0 bg-white z-50 h-14 px-1 flex items-center shadow-md">
  {/* Back Button */}
  <button 
    onClick={() => navigate(-1)} 
    className=" rounded-full active:scale-90 transition"
  >
    <img 
      src={ArrowLeft}
      alt="Back"
      className="h-8 w-12"
    />
  </button>
  {/* Header Title */}
  <h1 className="text-lg font-semibold text-gray-800">My Categories</h1>
</div>


            {/* Main Content */}
            <div className="px-6 py-5">
                <h2 className="text-lg font-semibold mb-2">Your Selling Categories</h2>
                <p className="text-[#000000] mb-5 text-sm">View and assign products to start selling.</p>

                {categories.length === 0 ? (
                    <div className="text-center py-12">
                        <div className="text-gray-400 text-6xl mb-4">📦</div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">No Categories Found</h3>
                        <p className="text-gray-600 mb-4">No categories are available for your vendor account.</p>
                        <button
                            onClick={onRefresh}
                            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors"
                        >
                            Refresh
                        </button>
                    </div>
                ) : (
                    <div className="space-y-3 mb-2 mt-6">
                        {categories.map((category) => (
                            <div
                                key={category.id}
                                className="flex items-center border rounded-lg p-3 cursor-pointer transition border-gray-200 hover:border-gray-300 hover:shadow-md"
                                onClick={() => handleCategoryPress(category)}
                            >
                                {/* Image */}
                              <div className="w-16 h-16 rounded-lg bg-gray-100 mr-4 flex items-center justify-center overflow-hidden">

  {category.image ? (
    <img
      src={category.image}
      alt={category.name}
      className="w-full h-full object-cover"
      onError={(e) => { e.target.style.display = "none"; }}
    />
  ) : (
    <FontAwesomeIcon icon={faImage} className="text-gray-400 text-3xl" />
  )}

</div>


                                {/* Text */}
                                <div className="flex-1">
                                    <p className="text-md font-semibold text-[#000000] mb-1">{category.name}</p>
                                    <p className="text-gray-600 text-sm ">
                                        Selling: {category.sellingCount}/{category.totalCount} SKUs
                                    </p>
                                </div>

                                {/* Right Arrow */}
                                <div className="ml-2">
                                    <svg
                                        className="w-4 h-4 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Sticky Footer */}
            {/* <div className="pb-28"></div> */}
        </div>
    );
};

export default MyCategories;
